import React, { Component } from 'react';
import ScrollupSection from '../components/scrollupSection/scrollUp';
import Header from '../components/welcomeSection/header';
import { Link } from 'react-router-dom'
import { validate } from 'uuid'

class CheckoutReceived extends Component {

    componentDidMount() {
        const { location } = this.props;
        const { ack } = location.state || {};

        if (!ack || !validate(ack)) {
            this.goToIndex();
        }
    }

    goToIndex = () => {
        this.props.history.push('/')
    }

    render() {
        return (
            <div className="miami">
                <ScrollupSection />
                <div className="all-area">
                    <Header />
                    <section className="section about-app-area ptb_50">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-6 text-center">
                                    <h2>Recibimos tu comprobante</h2>
                                    <p>Recibirás tus números por correo electrónico una vez verificado el pago. Recuerda, esto puede tardar en caso de transferencias interbancarias.</p>

                                    <Link to="/">
                                        <button className="buy-btn mt-3">Volver al inicio</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default CheckoutReceived;
